export const createScript = (scriptUrl: string) => {
  const scriptElement = document.createElement("script");
  scriptElement.type = "text/javascript";
  scriptElement.async = true;
  scriptElement.src = scriptUrl;
  return scriptElement;
};
